import { render, staticRenderFns } from "./salesAgent.vue?vue&type=template&id=1c8247ba&"
import script from "./salesAgent.vue?vue&type=script&lang=js&"
export * from "./salesAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports